import { useTranslation } from 'react-i18next'

import { getRentalPortalApplicantIdentityLabel } from '../../../../../RentalPortalApplicant'
import { useBookRentalPortalViewing } from '../../../../../RentalPortalViewing'
import { useRentalPortalProfileHeaderFooterMeasure } from '../../../../RentalPortalProfileHeaderFooter'
import {
  useApplicantProfileArchiveActions,
  useApplicantProfileContext,
} from '../../../RentalPortalApplicantProfile.hooks'
import { useApplicantProfileEmailsCompose } from '../../../RentalPortalApplicantProfileEmails'
import {
  APPLICANT_PROFILE_FOOTER_ACTION,
  APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION,
} from '../../RentalPortalApplicantProfileHeaderFooter.constants'
import {
  getApplicantProfileFooterActions,
  getApplicantProfileFooterBookViewingListing,
  getIsApplicantProfileFooterOnlyMore,
} from '../../RentalPortalApplicantProfileHeaderFooter.utils'

export function useApplicantProfileHeaderFooter() {
  const { t } = useTranslation()

  const { applicantData, handleEntityReload } = useApplicantProfileContext()

  const { handleClickArchive, handleClickRestore } =
    useApplicantProfileArchiveActions()

  const { handleClickCompose } = useApplicantProfileEmailsCompose()

  const { bookViewingModal, handleOpenBookViewing } =
    useBookRentalPortalViewing({
      onBooked: handleEntityReload,
    })

  function handleClickBookViewing() {
    handleOpenBookViewing({
      applicant: {
        label: getRentalPortalApplicantIdentityLabel({
          applicant: applicantData,
          t,
        }),
        stage: applicantData.stage,
        value: applicantData.id,
      },
      listing: getApplicantProfileFooterBookViewingListing({
        applicantData,
        t,
      }),
    })
  }

  const actionHandlers = {
    [APPLICANT_PROFILE_FOOTER_ACTION.bookViewing]: handleClickBookViewing,
    [APPLICANT_PROFILE_FOOTER_ACTION.email]: handleClickCompose,
    [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.archive]: handleClickArchive,
    [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.restore]: handleClickRestore,
  }

  const actions = getApplicantProfileFooterActions({ applicantData, t })

  const measure = useRentalPortalProfileHeaderFooterMeasure({ actions })

  function handleSelectMoreOption({ disabled, value }) {
    return disabled ? null : actionHandlers[value]?.()
  }

  return {
    ...measure,
    actionHandlers,
    bookViewingModal,
    handleSelectMoreOption,
    hasActions: actions.length > 0,
    isOnlyMoreWithAddNewText: getIsApplicantProfileFooterOnlyMore(measure),
  }
}
